import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { LOGIN_ROUTE_PATH } from "../app_utils/route_paths/resolver/PageRoutes";
import { BaseApiServiceImpl } from "../app_utils/api/BaseApiServiceImpl";
import { MessageUtils } from "../app_utils/utils/MessageUtils";
import { Messages } from "primereact/messages";

const ForgotPassword = () => {
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const history = useHistory();
  const message = useRef<any>();

  const goToLogin = () => {
    history.replace(LOGIN_ROUTE_PATH);
  };

  const submitEmail = () => {
    if (!emailAddress.trim()) {
      MessageUtils.showErrorMessage(message, "Email address is required");
      return;
    }
    if (!emailAddress.includes("@")) {
      MessageUtils.showErrorMessage(message, "Please enter a valid email address");
      return;
    }

    setIsSaving(true);
    new BaseApiServiceImpl("/api/v1/auth/forgot-password")
      .postRequestWithJsonResponse({ emailAddress: emailAddress })
      .then(async (response) => {
        setIsSaving(false);
        setEmailSent(true);
      })
      .catch((error) => {
        setIsSaving(false);
        MessageUtils.showErrorMessage(message, error.message);
      });
  };

  if (emailSent) {
    return (
      <div
        className="login-page flex flex-column"
        style={{
          background: "linear-gradient(to right, #4b79a1, #283e51)",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="login-panel card shadow-lg p-4 rounded-lg"
          style={{ maxWidth: "450px", width: "100%" }}
        >
          <div className="text-center mb-4">
            <i className="pi pi-envelope" style={{ fontSize: "4rem", color: "#4b79a1" }}></i>
            <h2 style={{ color: "#283e51", marginTop: "1rem" }}>Check Your Email</h2>
            <p className="text-muted">
              We've sent a password reset OTP to <strong>{emailAddress}</strong>.
              Please check your email and use the OTP to reset your password.
            </p>
          </div>
          <Button
            className="p-button-rounded p-button-primary w-full mt-3"
            label="BACK TO LOGIN"
            onClick={goToLogin}
            style={{
              backgroundColor: "#4b79a1",
              border: "none",
              width: "100%",
              fontSize: "1.1rem",
              padding: "0.75rem",
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="login-page flex flex-column"
      style={{
        background: "linear-gradient(to right, #4b79a1, #283e51)",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="login-panel card shadow-lg p-4 rounded-lg"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <h2 style={{ color: "#283e51" }}>Forgot Password?</h2>
          <p className="text-muted">
            Enter your email address and we'll send you an OTP to reset your password.
          </p>
        </div>

        <div className="p-inputgroup mt-3">
          <span className="p-inputgroup-addon">
            <i className="pi pi-envelope"></i>
          </span>
          <InputText
            type="email"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            placeholder="Email address"
            style={{ width: "100%" }}
          />
        </div>

        <Messages ref={message} style={{ width: "100%" }} />

        <Button
          loading={isSaving}
          className="p-button-rounded p-button-primary w-full mb-3 mt-3"
          label="SEND RESET OTP"
          onClick={submitEmail}
          style={{
            backgroundColor: "#4b79a1",
            border: "none",
            width: "100%",
            fontSize: "1.1rem",
            padding: "0.75rem",
          }}
        />

        <div className="text-center mt-3">
          <p className="text-muted">
            Remember your password?{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                goToLogin();
              }}
              style={{ color: "#4b79a1", fontWeight: "bold" }}
            >
              Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
